export function getSeverityFromNota(nota) {

    if (nota > 200) {
        return
    } else if (nota > 95) {
        return "success";
    } else if (nota >= 80) {
        return "info";
    } else if (nota >= 60) {
        return "warning";
    } else if (nota > 0)
        return "danger"

    else {
        return "neutral";
    }

}